import {Observable} from 'rxjs/Observable';

// Classes.
import {AthleteGeneralInfoItem} from '../fetching/types/athlete-general-info.item';


export class AthleteStruct {
  constructor(
    public Id: number,
    public FName: string,
    public GName: string,
    public WNameOrd: boolean,
    public NOC: string,
    public sCompleteName: string,
    public sPartialName: string) {}
}


export class AthleteContainer {
  constructor(
    public _id: string,
    public _rev: string,
    public athlete: AthleteStruct
  ) {}
}


export class AthleteSearchResult {
  constructor(
    public items: AthleteStruct[],
    public truncated: boolean,
  ) {};
}

export interface AthleteDatabaseServiceInterface {


  initDB(): void;

  dbIsReady(): Observable<boolean>;

  get(athId: number): Observable<AthleteStruct>;

  storeList(list: AthleteGeneralInfoItem[]): Observable<any>;

  search(query: string): Observable<AthleteSearchResult>;
}